import { useState } from 'react';

export const useBulkModal = <T>({ selectedRows, onClose }: { selectedRows: T[]; onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [items, setItems] = useState<T[]>([]);

  const open = () => {
    setItems(selectedRows);
    setIsOpen(true);
    onClose();
  };

  const close = () => {
    setIsOpen(false);
    setItems([]);
  };

  return { isOpen, items, open, close };
};
